export const GALLERY_LIST = [
  {
    name: 'Bến bằng lăng',
    resizeUrl: '/assets/images/qr_code/Bến bằng lăng.jpg',
    previewUrl: '/assets/images/qr_code/Bến bằng lăng.jpg',
    imgUrl: 'https://sites.google.com/view/ben-bang-lang/',
    label: 'ben-bang-lang',
    group: 'food-court',
    groupLabel: 'Food Court',
    sceneId: '691fc83c9d4e2e854cdc371a',
  },
  {
    name: 'Cardamom Wild Elephant',
    resizeUrl: '/assets/images/qr_code/Cardamom Wild Elephant.webp',
    previewUrl: '/assets/images/qr_code/Cardamom Wild Elephant.webp',
    imgUrl: 'https://sites.google.com/view/cardamom-wild-elephant/',
    label: 'cardamom-wild-elephant',
    group: 'food-court',
    groupLabel: 'Food Court',
    sceneId: '691fc83c9d4e2e854cdc371a',
  },
  {
    name: 'La Selva de Girasoles',
    resizeUrl: '/assets/images/qr_code/La Selva de Girasoles.png',
    previewUrl: '/assets/images/qr_code/La Selva de Girasoles.png',
    imgUrl: 'https://sites.google.com/view/la-selva-de-girasoles/',
    label: 'la-selva-de-girasoles',
    group: 'multifunctional-room',
    groupLabel: 'Multifunctional Room',
    sceneId: '691fcb379d4e2e854cdc39e9',
  },
  {
    name: 'Lotus Gardener in Danang',
    resizeUrl: '/assets/images/qr_code/Lotus Gardener in Danang.webp',
    previewUrl: '/assets/images/qr_code/Lotus Gardener in Danang.webp',
    imgUrl: 'https://sites.google.com/view/lotus-gardener/',
    label: 'lotus-gardener-in-danang',
    group: 'food-court',
    groupLabel: 'Food Court',
    sceneId: '691fc83c9d4e2e854cdc371a',
  },
  {
    name: 'Monkey Business in InterContinental Danang',
    resizeUrl:
      '/assets/images/qr_code/Monkey Business in InterContinental Danang.webp',
    previewUrl:
      '/assets/images/qr_code/Monkey Business in InterContinental Danang.webp',
    imgUrl: 'https://sites.google.com/view/monkey-business-danang/',
    label: 'monkey-business-in-intercontinental-danang',
    group: 'food-court',
    groupLabel: 'Food Court',
    sceneId: '691fc83c9d4e2e854cdc371a',
  },
  {
    name: 'Purple Kaktus 2',
    resizeUrl: '/assets/images/qr_code/Purple Kaktus 2.jpg',
    previewUrl: '/assets/images/qr_code/Purple Kaktus 2.jpg',
    imgUrl: 'https://sites.google.com/view/kaktus-2/',
    label: 'purple-kaktus-2',
    group: 'food-court',
    groupLabel: 'Food Court',
    sceneId: '691fc83c9d4e2e854cdc371a',
  },
  {
    name: 'Purple Kaktus 1',
    resizeUrl: '/assets/images/qr_code/Purple Kaktus 1.png',
    previewUrl: '/assets/images/qr_code/Purple Kaktus 1.png',
    imgUrl: 'https://sites.google.com/view/kaktus-1/',
    label: 'purple-kaktus-1',
    group: 'food-court',
    groupLabel: 'Food Court',
    sceneId: '691fc83c9d4e2e854cdc371a',
  },
  {
    name: 'Red-Shanked Doucs of The Marmalade',
    resizeUrl: '/assets/images/qr_code/Red-Shanked Doucs of The Marmalade.png',
    previewUrl: '/assets/images/qr_code/Red-Shanked Doucs of The Marmalade.png',
    imgUrl: 'https://sites.google.com/view/red-shanked-doucs-1/',
    label: 'red-shanked-doucs-of-the-marmalade',
    group: 'food-court',
    groupLabel: 'Food Court',
    sceneId: '691fc83c9d4e2e854cdc371a',
  },
  {
    name: 'Serves Him Right',
    resizeUrl: '/assets/images/qr_code/Serves Him Right.png',
    previewUrl: '/assets/images/qr_code/Serves Him Right.png',
    imgUrl: 'https://sites.google.com/view/serves-him/',
    label: 'serves-him-right',
    group: 'food-court',
    groupLabel: 'Food Court',
    sceneId: '691fc83c9d4e2e854cdc371a',
  },
  {
    name: 'Silk Road Or Silk River',
    resizeUrl: '/assets/images/qr_code/Silk Road Or Silk River.webp',
    previewUrl: '/assets/images/qr_code/Silk Road Or Silk River.webp',
    imgUrl: 'https://sites.google.com/view/silk-road-or-silk-river/',
    label: 'silk-road-or-silk-river',
    group: 'multifunctional-room',
    groupLabel: 'Multifunctional Room',
    sceneId: '691fcb379d4e2e854cdc39e9',
  },
  {
    name: 'Taking The Tube To Florence',
    resizeUrl: '/assets/images/qr_code/Taking The Tube To Florence.webp',
    previewUrl: '/assets/images/qr_code/Taking The Tube To Florence.webp',
    imgUrl: 'https://sites.google.com/view/taking-the-tube/',
    label: 'taking-the-tube-to-florence',
    group: 'multifunctional-room',
    groupLabel: 'Multifunctional Room',
    sceneId: '691fcb379d4e2e854cdc39e9',
  },
  {
    name: 'The Douc’s in the Pink',
    resizeUrl: '/assets/images/qr_code/The Douc’s in the Pink.webp',
    previewUrl: '/assets/images/qr_code/The Douc’s in the Pink.webp',
    imgUrl: 'https://sites.google.com/view/the-doucs/',
    label: 'the-doucs-in-the-pink',
    group: 'food-court',
    groupLabel: 'Food Court',
    sceneId: '691fc83c9d4e2e854cdc371a',
  },
  {
    name: 'The Perils of Ha Long bay',
    resizeUrl: '/assets/images/qr_code/The Perils of Ha Long bay.webp',
    previewUrl: '/assets/images/qr_code/The Perils of Ha Long bay.webp',
    imgUrl: 'https://sites.google.com/view/the-perils-of-halong/',
    label: 'the-perils-of-halong-bay',
    group: 'multifunctional-room',
    groupLabel: 'Multifunctional Room',
    sceneId: '691fcb379d4e2e854cdc39e9',
  },
  {
    name: 'The Snake Charmer',
    resizeUrl: '/assets/images/qr_code/The Snake Charmer.png',
    previewUrl: '/assets/images/qr_code/The Snake Charmer.png',
    imgUrl: 'https://sites.google.com/view/the-snake-charmer/',
    label: 'the-snake-charmer',
    group: 'multifunctional-room',
    groupLabel: 'Multifunctional Room',
    sceneId: '691fcb379d4e2e854cdc39e9',
  },
  {
    name: 'The Tricky Passage',
    resizeUrl: '/assets/images/qr_code/The Tricky Passage.webp',
    previewUrl: '/assets/images/qr_code/The Tricky Passage.webp',
    imgUrl: 'https://sites.google.com/view/the-tricky-passage/',
    label: 'the-tricky-passage',
    group: 'multifunctional-room',
    groupLabel: 'Multifunctional Room',
    sceneId: '691fcb379d4e2e854cdc39e9',
  },
  {
    name: 'The Vietnamese Aviators Meet Catherine Of Aragon In The Faroe Islands',
    resizeUrl:
      '/assets/images/qr_code/The Vietnamese Aviators Meet Catherine Of Aragon In The Faroe Islands.webp',
    previewUrl:
      '/assets/images/qr_code/The Vietnamese Aviators Meet Catherine Of Aragon In The Faroe Islands.webp',
    imgUrl: 'https://sites.google.com/view/the-vietnamese-aviators/',
    label:
      'the-vietnamese-aviators-meet-catherine-of-aragon-in-the-faroe-islands',
    group: 'multifunctional-room',
    groupLabel: 'Multifunctional Room',
    sceneId: '691fcb379d4e2e854cdc39e9',
  },
  {
    name: 'The Wild Leaves',
    resizeUrl: '/assets/images/qr_code/The Wild Leaves.webp',
    previewUrl: '/assets/images/qr_code/The Wild Leaves.webp',
    imgUrl: 'https://sites.google.com/view/wild-leaves/',
    label: 'the-wild-leaves',
    group: 'multifunctional-room',
    groupLabel: 'Multifunctional Room',
    sceneId: '691fcb379d4e2e854cdc39e9',
  },
  {
    name: 'Thiếu nữ bên cúc họa mi',
    resizeUrl: '/assets/images/qr_code/ThieuNuBenHoaCucHoaMi.png',
    previewUrl: '/assets/images/qr_code/ThieuNuBenHoaCucHoaMi.png',
    imgUrl: 'https://sites.google.com/view/thieu-nu-ben-cuc-hoa-mi/',
    label: 'thieu-nu-ben-cuc-hoa-mi',
    group: 'food-court',
    groupLabel: 'Food Court',
    sceneId: '691fc83c9d4e2e854cdc371a',
  },
  {
    name: 'Tropical Underwater 2',
    resizeUrl: '/assets/images/qr_code/Tropical Underwater 2.webp',
    previewUrl: '/assets/images/qr_code/Tropical Underwater 2.webp',
    imgUrl: 'https://sites.google.com/view/tropical-2/',
    label: 'tropical-underwater-2',
    group: 'multifunctional-room',
    groupLabel: 'Multifunctional Room',
    sceneId: '691fcb379d4e2e854cdc39e9',
  },
  {
    name: 'Tropical Underwater',
    resizeUrl: '/assets/images/qr_code/Tropical Underwater.png',
    previewUrl: '/assets/images/qr_code/Tropical Underwater.png',
    imgUrl: 'https://sites.google.com/view/tropical-underwater/',
    label: 'tropical-underwater',
    group: 'multifunctional-room',
    groupLabel: 'Multifunctional Room',
    sceneId: '691fcb379d4e2e854cdc39e9',
  },
  {
    name: 'Who Sail “OLD”',
    resizeUrl: '/assets/images/qr_code/Who Sail “OLD”.webp',
    previewUrl: '/assets/images/qr_code/Who Sail “OLD”.webp',
    imgUrl: 'https://sites.google.com/view/who-sail-old/',
    label: 'who-sail-old',
    group: 'multifunctional-room',
    groupLabel: 'Multifunctional Room',
    sceneId: '691fcb379d4e2e854cdc39e9',
  },
  {
    name: 'Wild Forest',
    resizeUrl: '/assets/images/qr_code/Wild Forest.webp',
    previewUrl: '/assets/images/qr_code/Wild Forest.webp',
    imgUrl: 'https://sites.google.com/view/wild-forest/',
    label: 'wild-forest',
    group: 'food-court',
    groupLabel: 'Food Court',
    sceneId: '691fc83c9d4e2e854cdc371a',
  },
  {
    name: 'Does Anyone Need Some Lemonade ?',
    resizeUrl: '/assets/images/qr_code/Does Anyone Need Some Lemonade.webp',
    previewUrl: '/assets/images/qr_code/Does Anyone Need Some Lemonade.webp',
    imgUrl:
      'https://sites.google.com/view/painting-info/-/does-anyone-need-some-lemonades',
    label: 'does-anyone-need-some-lemonade',
    group: 'food-court',
    groupLabel: 'Food Court',
    sceneId: '691fc83c9d4e2e854cdc371a',
  },
  {
    name: 'Twining Con Hổ 1',
    resizeUrl: '/assets/images/qr_code/TWINING CON HỔ 1.webp',
    previewUrl: '/assets/images/qr_code/TWINING CON HỔ 1.webp',
    imgUrl: 'https://sites.google.com/view/painting-info/-/twining-con-ho-1',
    label: 'twining-con-ho-1',
    group: 'food-court',
    groupLabel: 'Food Court',
    sceneId: '691fc83c9d4e2e854cdc371a',
  },
  {
    name: 'The Douc’s Family',
    resizeUrl: '/assets/images/qr_code/THE DOUC’S FAMILY.png',
    previewUrl: '/assets/images/qr_code/THE DOUC’S FAMILY.png',
    imgUrl: 'https://sites.google.com/view/painting-info/-/the-douc-s-family',
    label: 'the-doucs-family',
    group: 'food-court',
    groupLabel: 'Food Court',
    sceneId: '691fc83c9d4e2e854cdc371a',
  },
  {
    name: 'Jungle Trio 1',
    resizeUrl: '/assets/images/qr_code/JUNGLE TRIO 1.png',
    previewUrl: '/assets/images/qr_code/JUNGLE TRIO 1.png',
    imgUrl: 'https://sites.google.com/view/painting-info/-/jungle-trio',
    label: 'jungle-trio-1',
    group: 'food-court',
    groupLabel: 'Food Court',
    sceneId: '691fc83c9d4e2e854cdc371a',
  },
  {
    name: 'Dừa nước ven sông',
    resizeUrl: '/assets/images/qr_code/Dua_nuoc_ven_song.png',
    previewUrl: '/assets/images/qr_code/Dua_nuoc_ven_song.png',
    imgUrl: 'https://sites.google.com/view/dua-nuoc-ven-song/',
    label: 'dua-nuoc-ven-song',
    group: 'food-court',
    groupLabel: 'Food Court',
    sceneId: '691fc83c9d4e2e854cdc371a',
  },
  {
    name: 'Wildlife Loves Wildflowers',
    resizeUrl: '/assets/images/qr_code/WILDLIFE LOVES WILDFLOWERS.webp',
    previewUrl: '/assets/images/qr_code/WILDLIFE LOVES WILDFLOWERS.webp',
    imgUrl:
      'https://sites.google.com/view/painting-info/-/wildlife-loves-wildflowers',
    label: 'wildlife-loves-wildflowers',
    group: 'food-court',
    groupLabel: 'Food Court',
    sceneId: '691fc83c9d4e2e854cdc371a',
  },
  {
    name: 'Jungle Trio 2',
    resizeUrl: '/assets/images/qr_code/JUNGLE TRIO 2.png',
    previewUrl: '/assets/images/qr_code/JUNGLE TRIO 2.png',
    imgUrl: 'https://sites.google.com/view/painting-info/-/jungle-trio-2',
    label: 'jungle-trio-2',
    group: 'food-court',
    groupLabel: 'Food Court',
    sceneId: '691fc83c9d4e2e854cdc371a',
  },
  {
    name: 'Nửa vầng trăng No.1',
    resizeUrl: '/assets/images/qr_code/Nua_vang_trang.png',
    previewUrl: '/assets/images/qr_code/Nua_vang_trang.png',
    imgUrl: 'https://sites.google.com/view/nua-vang-trang-1/',
    label: 'nua-vang-trang-1',
    group: 'food-court',
    groupLabel: 'Food Court',
    sceneId: '691fc83c9d4e2e854cdc371a',
  },
  {
    name: 'The Family Tree',
    resizeUrl: '/assets/images/qr_code/THE FAMILY TREE.webp',
    previewUrl: '/assets/images/qr_code/THE FAMILY TREE.webp',
    imgUrl: 'https://sites.google.com/view/painting-info/-/the-family-tree',
    label: 'the-family-tree',
    group: 'food-court',
    groupLabel: 'Food Court',
    sceneId: '691fc83c9d4e2e854cdc371a',
  },
  {
    name: 'Red Shanked Douc II',
    resizeUrl: '/assets/images/qr_code/RED SHANKED DOUC II.webp',
    previewUrl: '/assets/images/qr_code/RED SHANKED DOUC II.webp',
    imgUrl: 'https://sites.google.com/view/painting-info/-/red-shanked-douc-ii',
    label: 'red-shanked-douc-2',
    group: 'food-court',
    groupLabel: 'Food Court',
    sceneId: '691fc83c9d4e2e854cdc371a',
  },
  {
    name: 'All The Tiger’s Friends',
    resizeUrl: '/assets/images/qr_code/ALL THE TIGERS FRIENDS.png',
    previewUrl: '/assets/images/qr_code/ALL THE TIGERS FRIENDS.png',
    imgUrl:
      'https://sites.google.com/view/painting-info/-/all-the-tiger-s-friends',
    label: 'all-the-tigers-friends',
    group: 'food-court',
    groupLabel: 'Food Court',
    sceneId: '691fc83c9d4e2e854cdc371a',
  },
  {
    name: 'The Wild Elephant',
    resizeUrl: '/assets/images/qr_code/THE WILD ELEPHANT.png',
    previewUrl: '/assets/images/qr_code/THE WILD ELEPHANT.png',
    imgUrl: 'https://sites.google.com/view/painting-info/-/the-wild-elephant',
    label: 'the-wild-elephant',
    group: 'food-court',
    groupLabel: 'Food Court',
    sceneId: '691fc83c9d4e2e854cdc371a',
  },
  {
    name: 'Twining Con Hổ 2',
    resizeUrl: '/assets/images/qr_code/TWINING CON HỔ 2.webp',
    previewUrl: '/assets/images/qr_code/TWINING CON HỔ 2.webp',
    imgUrl: 'https://sites.google.com/view/painting-info/-/twining-con-ho-2',
    label: 'twining-con-ho-2',
    group: 'food-court',
    groupLabel: 'Food Court',
    sceneId: '691fc83c9d4e2e854cdc371a',
  },
  {
    name: 'The Birds Conference',
    resizeUrl: '/assets/images/qr_code/THE BIRDS CONFERENCE.webp',
    previewUrl: '/assets/images/qr_code/THE BIRDS CONFERENCE.webp',
    imgUrl:
      'https://sites.google.com/view/painting-info/-/the-birds-conference',
    label: 'the-birds-conference',
    group: 'food-court',
    groupLabel: 'Food Court',
    sceneId: '691fc83c9d4e2e854cdc371a',
  },
  {
    name: 'Marmalade Chim Chim Forest',
    resizeUrl: '/assets/images/qr_code/MARMALADE CHIM CHIM FOREST.png',
    previewUrl: '/assets/images/qr_code/MARMALADE CHIM CHIM FOREST.png',
    imgUrl:
      'https://sites.google.com/view/painting-info/-/marmalade-chim-chim-forest',
    label: 'marmalade-chim-chim-forest',
    group: 'food-court',
    groupLabel: 'Food Court',
    sceneId: '691fc83c9d4e2e854cdc371a',
  },
  {
    name: 'Red Shanked Douc IV',
    resizeUrl: '/assets/images/qr_code/RED SHANKED DOUC IV.webp',
    previewUrl: '/assets/images/qr_code/RED SHANKED DOUC IV.webp',
    imgUrl: 'https://sites.google.com/view/painting-info/-/red-shanked-douc-iv',
    label: 'red-shanked-douc-iv',
    group: 'food-court',
    groupLabel: 'Food Court',
    sceneId: '691fc83c9d4e2e854cdc371a',
  },
  {
    name: 'Long Lost Brothers, Griffin',
    resizeUrl: '/assets/images/qr_code/LONG LOST BROTHERS, GRIFFIN.png',
    previewUrl: '/assets/images/qr_code/LONG LOST BROTHERS, GRIFFIN.png',
    imgUrl:
      'https://sites.google.com/view/painting-info/-/long-lost-brothers-griffin',
    label: 'long-lost-brothers-griffin',
    group: 'food-court',
    groupLabel: 'Food Court',
    sceneId: '691fc83c9d4e2e854cdc371a',
  },
];

export const GALLERY_MAP = {
  'ben-bang-lang': {
    label: 'Bến bằng lăng',
    url: `/gallery/ben-bang-lang`,
  },
  'cardamom-wild-elephant': {
    label: 'Cardamom Wild Elephant',
    url: `/gallery/cardamom-wild-elephant`,
  },
  'esperando-tu-llegada': {
    label: 'Esperando tu Llegada',
    url: `/gallery/esperando-tu-llegada`,
  },
  'florero-primavera-azul': {
    label: 'Florero Primavera Azul',
    url: `/gallery/florero-primavera-azul`,
  },
  'la-selva-de-girasoles': {
    label: 'La Selva de Girasoles',
    url: `/gallery/la-selva-de-girasoles`,
  },
  'lotus-gardener-in-danang': {
    label: 'Lotus Gardener in Danang',
    url: `/gallery/lotus-gardener-in-danang`,
  },
  'monkey-business-in-intercontinental-danang': {
    label: 'Monkey Business in InterContinental Danang',
    url: `/gallery/monkey-business-in-intercontinental-danang`,
  },
  'purple-kaktus-2': {
    label: 'Purple Kaktus 2',
    url: `/gallery/purple-kaktus-2`,
  },
  'purple-kaktus-1': {
    label: 'Purple Kaktus 1',
    url: `/gallery/purple-kaktus-1`,
  },
  'red-shanked-doucs-in-the-wild': {
    label: 'Red Shanked Doucs in the Wild',
    url: `/gallery/red-shanked-doucs-in-the-wild`,
  },
  'red-shanked-doucs-of-the-marmalade': {
    label: 'Red Shanked Doucs of The Marmalade',
    url: `/gallery/red-shanked-doucs-of-the-marmalade`,
  },
  'serves-him-right': {
    label: 'Serves Him Right',
    url: `/gallery/serves-him-right`,
  },
  'silk-road-or-silk-river': {
    label: 'Silk Road Or Silk River',
    url: `/gallery/silk-road-or-silk-river`,
  },
  'taking-the-tube-to-florence': {
    label: 'Taking The Tube To Florence',
    url: `/gallery/taking-the-tube-to-florence`,
  },
  'the-doucs-in-the-pink': {
    label: 'The Doucs in the Pink',
    url: `/gallery/the-doucs-in-the-pink`,
  },
  'the-perils-of-halong-bay': {
    label: 'The Perils of Ha Long bay',
    url: `/gallery/the-perils-of-halong-bay`,
  },
  'the-snake-charmer': {
    label: 'The Snake Charmer',
    url: `/gallery/the-snake-charmer`,
  },
  'the-tricky-passage': {
    label: 'The Tricky Passage',
    url: `/gallery/the-tricky-passage`,
  },
  'the-vietnamese-aviators-meet-catherine-of-aragon-in-the-faroe-islands': {
    label:
      'The Vietnamese Aviators Meet Catherine Of Aragon In The Faroe Islands',
    url: `/gallery/the-vietnamese-aviators-meet-catherine-of-aragon-in-the-faroe-islands`,
  },
  'the-wild-leaves': {
    label: 'The Wild Leaves',
    url: `/gallery/the-wild-leaves`,
  },
  'thieu-nu-ben-cuc-hoa-mi': {
    label: 'Thiếu nữ bên cúc họa mi',
    url: `/gallery/thieu-nu-ben-cuc-hoa-mi`,
  },
  'tropical-underwater-2': {
    label: 'Tropical Underwater 2',
    url: `/gallery/tropical-underwater-2`,
  },
  'tropical-underwater': {
    label: 'Tropical Underwater',
    url: `/gallery/tropical-underwater`,
  },
  'who-sail-old': {
    label: 'Who Sail “OLD”',
    url: `/gallery/who-sail-old`,
  },
  'wild-forest': {
    label: 'Wild Forest',
    url: `/gallery/wild-forest`,
  },
  'does-anyone-need-some-lemonade': {
    label: 'Does Anyone Need Some Lemonade ?',
    url: `/gallery/does-anyone-need-some-lemonade`,
  },
  'twining-con-ho-1': {
    label: 'Twining Con Hổ 1',
    url: `/gallery/twining-con-ho-1`,
  },
  'the-doucs-family': {
    label: 'The Doucs Family',
    url: `/gallery/the-doucs-family`,
  },
  'jungle-trio-1': {
    label: 'Jungle Trio 1',
    url: `/gallery/jungle-trio-1`,
  },
  'dua-nuoc-ven-song': {
    label: 'Dừa nước ven sông',
    url: `/gallery/dua-nuoc-ven-song`,
  },
  'wildlife-loves-wildflowers': {
    label: 'Wildlife Loves Wildflowers',
    url: `/gallery/wildlife-loves-wildflowers`,
  },
  'jungle-trio-2': {
    label: 'Jungle Trio 2',
    url: `/gallery/jungle-trio-2`,
  },
  'nua-vang-trang-1': {
    label: 'Nửa vầng trăng No.1',
    url: `/gallery/nua-vang-trang-1`,
  },
  'the-family-tree': {
    label: 'The Family Tree',
    url: `/gallery/the-family-tree`,
  },
  'red-shanked-douc-2': {
    label: 'Red Shanked Douc II',
    url: `/gallery/red-shanked-douc-2`,
  },
  'all-the-tigers-friends': {
    label: 'All The Tigers Friends',
    url: `/gallery/all-the-tigers-friends`,
  },
  'the-wild-elephant': {
    label: 'The Wild Elephant',
    url: `/gallery/the-wild-elephant`,
  },
  'twining-con-ho-2': {
    label: 'Twining Con Hổ 2',
    url: `/gallery/twining-con-ho-2`,
  },
  'the-birds-conference': {
    label: 'The Birds Conference',
    url: `/gallery/the-birds-conference`,
  },
  'marmalade-chim-chim-forest': {
    label: 'Marmalade Chim Chim Forest',
    url: `/gallery/marmalade-chim-chim-forest`,
  },
  'red-shanked-douc-iv': {
    label: 'Red Shanked Douc IV',
    url: `/gallery/red-shanked-douc-iv`,
  },
  'long-lost-brothers-griffin': {
    label: 'Long Lost Brothers, Griffin',
    url: `/gallery/long-lost-brothers-griffin`,
  },
};
